import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { BehaviorSubject, Observable } from 'rxjs';
import { URL_SERVICIOS_SOCKET, ENVIRONMENT } from '../config/config';

@Injectable({ providedIn: 'root' })
export class MercadoPagoSocketService {
  private socket: Socket;
  private paymentStatus$ = new BehaviorSubject<any>(null);

  constructor() {
    this.socket = io(URL_SERVICIOS_SOCKET, { transports: ['websocket'], withCredentials: true });
    this.socket.on('connect', () => console.log('✅ Socket de pagos conectado', 'socket:', this.socket.id, 'url:', URL_SERVICIOS_SOCKET, 'ambiente:', ENVIRONMENT));
    this.socket.on('connect_error', (err) => console.error('❌ Error de conexión socket de pagos:', err, 'url:', URL_SERVICIOS_SOCKET, 'ambiente:', ENVIRONMENT));

    this.socket.on('mercadopago:PaymentStatus', (data: any) => {
      console.log('📥 Resultado Mercado Pago:', data);
      this.emitPaymentStatus('MERCADO_PAGO', data);
    });

    this.socket.on('virtualpos:PaymentStatus', (data: any) => {
      console.log('📥 Resultado VirtualPOS:', data);
      this.emitPaymentStatus('VIRTUAL_POS', data);
    });
  }

  private emitPaymentStatus(providerPay: 'MERCADO_PAGO' | 'VIRTUAL_POS', data: any): void {
    const payload = data && typeof data === 'object' ? { ...data } : { data };
    if (!payload.providerPay && !payload.provider && !payload.sub_pay_provider) payload.providerPay = providerPay;
    this.paymentStatus$.next(payload);
  }

  PaymentStatus(): Observable<any> {
    return this.paymentStatus$.asObservable();
  }
}
